import React, { PureComponent } from 'react';
import gettext from '@eb/gettext';

import { ValidationFormField } from '@eb/eds-validation-form-field';
import { InputField } from '@eb/eds-input-field';

import { shouldDisplayError } from '@eb/redux-form-tools';

export default class ConfirmEmailField extends PureComponent {
    _handlePaste(e) {
        // Avoid paste in input
        e.preventDefault();
    }

    render() {
        return (
            <div className="eds-l-mar-bot-4">
                <ValidationFormField
                    name="confirmEmail"
                    label={gettext('Confirm email')}
                    shouldDisplayError={shouldDisplayError}
                    v2={true}
                >
                    <InputField
                        id="confirmEmail"
                        name="confirmEmail"
                        autoFocus={true}
                        onPaste={this._handlePaste}
                        label={gettext('Confirm email')}
                        type="email"
                        role="textbox"
                        data-automation="authentication-email-confirm-field"
                    />
                </ValidationFormField>
            </div>
        );
    }
}
